import { useLocation } from "react-router-dom";
import { Info } from "lucide-react";
import { useI18n } from "@/lib/i18n";

/**
 * Pages still pending translation (kept as exclude list).
 * Add a path here to show the banner while it's not translated yet.
 */
const PENDING_PATHS = [];

const TRANSLATED_TEXT = {
  ca: {
    text: "Aquesta pàgina encara està disponible només en castellà. La resta del web es pot llegir en català.",
  },
};

const TranslationBanner = () => {
  const { lang } = useI18n();
  const location = useLocation();

  if (lang !== "ca") return null;
  if (location.pathname.startsWith("/admin")) return null;
  if (!PENDING_PATHS.includes(location.pathname)) return null;

  const copy = TRANSLATED_TEXT.ca;

  return (
    <div
      className="bg-cream/80 border-b border-sand/60 backdrop-blur-sm"
      data-testid="translation-banner"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-2.5 flex items-center gap-3 text-[12.5px] text-charcoal/75">
        <Info size={14} className="text-terracotta shrink-0" />
        <p className="flex-1 leading-relaxed">
          {copy.text}
        </p>
      </div>
    </div>
  );
};

export default TranslationBanner;
